// extracted by mini-css-extract-plugin
export var cell = "_5x-4";
export var headerCell = "_5x-2";
export var rowHeader = "_5x-3";
export var table = "_5x-1";
export var tableContainer = "_5x-0";